import Thesaurus from "./Thesaurus";

export default Thesaurus;